// extracted by mini-css-extract-plugin
module.exports = {"eq":"Checkbox_eq__2HfCZ","pl":"Checkbox_pl__2pw8v","shuffle":"Checkbox_shuffle__2OIRX","repeat":"Checkbox_repeat__31RPz"};